import { render, staticRenderFns } from "./GalleryWidget.vue?vue&type=template&id=055fa3d6&"
import script from "./GalleryWidget.vue?vue&type=script&lang=js&"
export * from "./GalleryWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('055fa3d6')) {
      api.createRecord('055fa3d6', component.options)
    } else {
      api.reload('055fa3d6', component.options)
    }
    module.hot.accept("./GalleryWidget.vue?vue&type=template&id=055fa3d6&", function () {
      api.rerender('055fa3d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dynamic-list-items/widgets/GalleryWidget.vue"
export default component.exports